import {DragIcon, SettingsIcon} from 'assests/GmsIcons';
import React, { ChangeEvent} from 'react';
import ToggleEyeButton from './ToggleEyeButton';
import { TField } from '../ui';
import { BOOLEAN, DECIMAL, FIELD, FRACTION, INTEGER, MULTI_CHOICE, TEXT_FIELD, RANGE_FIELD } from 'Pages/GMS/ISR/ISRConstants';
import { colorTheme } from '../ColorTheme';

type TUIFieldItem = {
    field: TField;
    fieldIndex: number;
    modelIndex?: number;
    deleteField?: (fieldIndex: number) => void;
    updateField: (field: TField, fieldIndex: number, modelIndex?: number) => void;
    dragHandleProps?: any;
    setEditFlag?: any;
    setEditField? : any;
}

const UIFieldItem = ({field, fieldIndex, modelIndex, updateField, dragHandleProps, setEditFlag, setEditField}: TUIFieldItem) => {
    const optionsMap = new Map([
        [MULTI_CHOICE, ['Checkbox', 'Radio Button', 'Drop down', 'Chip']],
        [TEXT_FIELD, ['Text Field', 'Label']],
        [FIELD, ['Text Field']],
        [INTEGER, ['Text Field']],
        [RANGE_FIELD, ['Range Field']],
        [DECIMAL, ['Text Field']],
        [BOOLEAN, ['Drop down', 'Radio Button', 'Toggle']],
        [FRACTION, ['Text Field']],
    ]);

    const handleHiddenChange = () => {
        updateField({...field, isFieldVisible: !field?.isFieldVisible}, fieldIndex, modelIndex);
    }

    const handleFieldTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
        updateField({...field, fieldType: event.target.value}, fieldIndex, modelIndex);
    }

    const selectTypes = optionsMap.get(field?.modelFieldType);

    const fieldTypeChoice = (field: TField) => {
        if (field?.fieldType) {
            return field?.fieldType
        }
        else {
            if(field?.modelFieldType === MULTI_CHOICE) {
                return 'Checkbox'
            } else if([TEXT_FIELD, FIELD, INTEGER, DECIMAL, FRACTION].includes(field?.modelFieldType)) {
                return 'Text Field'
            }
            else {
                return '';
            }
        }
    }

    return (
        <div className='tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-[104px] tw-border-[2px] tw-border-solid tw-border-[#f4f4f7] tw-mt-2'>
            <div className="tw-flex tw-items-center tw-justify-between tw-rounded-t tw-rounded-b-none tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-[38px] tw-border-[1px] tw-border-solid tw-border-[#dadbdd] tw-px-3">
                <div className="tw-flex tw-items-center tw-gap-3">
                    {/* <DragIcon /> */}
                    <div {...dragHandleProps}>
                        <DragIcon />
                    </div>
                    <label className="tw-text-[#090A42] tw-text-sm tw-ml-4"
                        style={{color: colorTheme.title}}
                    >{field?.fieldName ?? ''}</label>
                </div>
                {/* <div className="tw-w-36 tw-h-8 tw-px-3 tw-py-2 tw-rounded tw-border tw-justify-center tw-items-center tw-gap-2 tw-inline-flex tw-cursor-pointer"
                    onClick={() => {
                        setEditField({
                            field: field,
                            fieldIndex: fieldIndex,
                            modelIndex: modelIndex,
                        });
                        setEditFlag(true);
                    }}
                >
                    <div className="tw-w-5 tw-h-5 tw-relative tw-bg-zinc-300 tw-bg-opacity-50 tw-rounded-[40px] tw-flex-col tw-justify-start tw-items-start tw-inline-flex">
                        <div className="tw-w-[8.75px] tw-h-[10.23px] tw-relative">
                        </div>

                        <img src={UIBehaviorIcon} alt="Active" />
                    </div>
                    <div className="tw-text-center tw-text-blue-950 tw-text-sm  tw-leading-tight">UI Behavior</div>
                </div> */}
                <div className="tw-flex tw-items-center tw-gap-3">
                    <ToggleEyeButton isClicked={field?.isFieldVisible ?? false}
                                     onClick={handleHiddenChange}/>
                    <button className={`tw-focus:outline-none`} onClick={() => {
                        setEditField({
                            field: field,
                            fieldIndex: fieldIndex,
                            modelIndex: modelIndex,
                        });
                        setEditFlag(true);
                    }}>
                        <SettingsIcon/>
                    </button>

                    {/* <button onClick={() => deleteField(fieldIndex)}>
                        <DeleteIcon />
                    </button> */}
                </div>
            </div>
            <div className='tw-flex tw-justify-between tw-text-center tw-items-center tw-mt-2.5'>
                <div className="tw-rounded tw-bg-[#f4f4f7] tw-box-border tw-w-[440px] tw-flex tw-flex-row tw-items-center tw-justify-start tw-py-2 tw-px-2.5 tw-gap-[10px] tw-text-sm tw-border-[1px] tw-border-solid tw-border-[#ebecf0] tw-ms-3"
                    style={{backgroundColor: colorTheme.background}}
                >{field?.fieldName ?? ''}</div>
                <div className='tw-flex tw-me-3'>
                    <select className="drop-down-dm tw-w-[180px] tw-py-2" value={fieldTypeChoice(field)} onChange={handleFieldTypeChange} >
                        <option>
                            Select Type
                        </option>
                            {selectTypes && selectTypes.map((item, index) => {
                                return (
                                    <option value={item} key={item + index}>
                                    {item}
                            </option>);
                        })}
                    </select>
                </div>
            </div>
        </div>
    );
}

export default UIFieldItem;